import { makeStyles } from '@material-ui/core';
import LogoIcon from './LogoIcon';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  text: {
    color: '#7df3e1',
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: 1,
    whiteSpace: 'nowrap',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <LogoIcon />
      <span className={classes.text}>Exo DevOps</span>
    </div>
  );
};

export default LogoFull;
